export const Idea = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.33203 8.3344C3.33203 4.65209 6.31713 1.66699 9.99943 1.66699C13.6817 1.66699 16.6668 4.65209 16.6668 8.3344C16.6668 10.4887 15.6444 12.4045 14.0609 13.6224C13.8301 13.7999 13.5872 13.9627 13.3338 14.1093V14.167H6.66512V14.1093C6.41165 13.9627 6.16879 13.7999 5.93795 13.6224C4.35445 12.4045 3.33203 10.4887 3.33203 8.3344Z"
      fill="#F6B60E"
    />
    <path
      d="M6.66512 15.417V15.8327C6.66512 17.6742 8.15794 19.167 9.99943 19.167C11.8409 19.167 13.3338 17.6742 13.3338 15.8327V15.417H6.66512Z"
      fill="#F6B60E"
    />
  </svg>
)

export default Idea
